var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDashOrders = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30.788,
  height: 36.088,
  viewBox: "0 0 30.788 36.088",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_1235",
  "data-name": "Group 1235",
  transform: "translate(-413.062 -292.15)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Symbol_6_1",
  "data-name": "Symbol 6 \\u2013 1",
  transform: "translate(413.412 292.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_102",
  "data-name": "Path 102",
  d: "M74.16,929.411V896.5a1.145,1.145,0,0,1,1.186-1.139H102.1a1.144,1.144,0,0,1,1.15,1.139v32.913l-5.883-2.129-5.153,2.176L87.8,927.282l-4.412,2.176-4.412-2.176-4.418,2.176",
  transform: "translate(-73.66 -894.859)",
  fill: "none",
  stroke: "#153968",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.7
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_239",
  "data-name": "Rectangle 239",
  width: 23.484,
  height: 0.878,
  transform: "translate(3.341 25.177)",
  fill: "#153968",
  stroke: "#153968",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_240",
  "data-name": "Rectangle 240",
  width: 23.484,
  height: 0.878,
  transform: "translate(3.341 14.947)",
  fill: "#153968",
  stroke: "#153968",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_241",
  "data-name": "Rectangle 241",
  width: 23.484,
  height: 0.878,
  transform: "translate(3.341 20.059)",
  fill: "#153968",
  stroke: "#153968",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_242",
  "data-name": "Rectangle 242",
  width: 10.769,
  height: 0.901,
  transform: "translate(3.341 4.717)",
  fill: "#153968",
  stroke: "#153968",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_243",
  "data-name": "Rectangle 243",
  width: 23.484,
  height: 0.878,
  transform: "translate(3.341 9.829)",
  fill: "#153968",
  stroke: "#153968",
  strokeWidth: 0.7
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashOrders, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dash_orders.c145de3b.svg";
export { ForwardRef as ReactComponent };